/**
 * Formats the dataset's `generatedAt` for the footer.
 *
 * The page refreshes every 15 minutes, so on a launch Sunday "spots left" can
 * legitimately be a few minutes behind CCB. This line lets anyone who wonders
 * how current the list is check for themselves, without putting a timestamp in
 * front of people who don't care.
 *
 * Rendered in the viewer's own timezone — nearly all of them are local anyway,
 * and a fixed church timezone would read as wrong to anyone who isn't.
 *
 * @param now injectable so the today/not-today branch is testable.
 */
export function formatUpdatedAt(
  iso: string | null | undefined,
  now: Date = new Date()
): string | null {
  if (!iso) return null;

  const when = new Date(iso);
  if (Number.isNaN(when.getTime())) return null;

  const time = when.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });

  const sameDay =
    when.getFullYear() === now.getFullYear() &&
    when.getMonth() === now.getMonth() &&
    when.getDate() === now.getDate();

  if (sameDay) return `Group list updated today at ${time}`;

  const date = when.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  return `Group list updated ${date} at ${time}`;
}
